import { useState, useEffect } from "react";

export function useTimeAgo(timestamp: number | undefined): string {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (timestamp === undefined || timestamp === 0) return;
    const id = setInterval(() => setTick((t) => t + 1), 5_000);
    return () => clearInterval(id);
  }, [timestamp]);

  if (timestamp === undefined || timestamp === 0) return "";
  const seconds = Math.round((Date.now() - timestamp) / 1_000);
  if (seconds < 0) return "just now";
  if (seconds < 5) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  return `${Math.floor(minutes / 60)}h ago`;
}
